import React from 'react'

import { Grid } from '../../../packages/kiti/components/structure/Grid'

const CardsList = ({ Card, Loader }) => {
  const list = Loader.useList()

  return (
    <Grid direction="column" gap={0.6}>
      {list.map(item => (
        <Card key={item.id} item={item} />
      ))}
    </Grid>
  )
}

export default CardsList
